import React from 'react';
import { connect } from 'react-redux';

import { baseMapStateToProps } from '../../componentBase';
import { ClippingPlatformState } from '../../../store/clippingPlatformState';
import { callApi } from '../../../helpers/callApi/callApi';
import * as NotificationHelper from '../../../helpers/notificationHelper';
import {
  deleteAfterEffectsMusic,
  getAfterEffectsMusicFiles,
  uploadAfterEffectsMusicFile,
} from '../../../api/clipGenV2/afterEffectsMusic.actions';
import { createModalCloseAction } from '../../../actions/modalActions';
import { SimpleModalId } from '../../../constants/modalId';

import { MusicUploadFormContainer } from './musicUploadForm';
import { MusicManagementProps, MusicManagementState, MusicUploadFormDataProps } from './music.types';
import { MusicTable } from './musicTable';

export class MusicManagement extends React.Component<MusicManagementProps, MusicManagementState> {
  state: MusicManagementState = {
    isUploadingMusic: false,
    deleteMusicLoading: false,
  };

  onMusicUpload = (values: MusicUploadFormDataProps) => {
    const { closeMusicUploadModal, uploadAfterEffectsMusic, fetchMusic } = this.props;
    callApi({
      action: () => {
        this.setState(prev => ({ ...prev, isUploadingMusic: true }));

        return uploadAfterEffectsMusic(values);
      },
      onSuccess: () => {
        this.setState(prev => ({ ...prev, isUploadingMusic: false }));
        closeMusicUploadModal();
        NotificationHelper.success('Successfully uploaded music file!');
        fetchMusic();
      },
      onFailure: () => {
        this.setState(prev => ({ ...prev, isUploadingMusic: false }));
        NotificationHelper.error('Failed to upload music file!');
      },
    });
  };

  deleteMusic = (musicId: string) => {
    const { deleteMusic, fetchMusic } = this.props;

    callApi({
      action: () => {
        this.setState(prev => ({ ...prev, deleteMusicLoading: true }));

        return deleteMusic(musicId);
      },
      onSuccess: () => {
        this.setState(prev => ({ ...prev, deleteMusicLoading: false }));
        NotificationHelper.success('Successfully deleted music!');
        fetchMusic();
      },
      onFailure: () => {
        this.setState(prev => ({ ...prev, deleteMusicLoading: false }));
        NotificationHelper.error('Failed to delete music!');
      },
    });
  };

  render = () => {
    const { isUploadingMusic, deleteMusicLoading } = this.state;
    const { music, getMusicError, getMusicLoading, getInstituteLoading, institutes } = this.props;

    if (getMusicError) {
      return <div>Something went wrong</div>;
    }
    const isLoading = isUploadingMusic || deleteMusicLoading || getMusicLoading;

    return (
      <>
        <MusicUploadFormContainer
          onUpload={this.onMusicUpload}
          isLoading={isUploadingMusic}
          institutes={institutes}
          institutesLoading={getInstituteLoading}
        />
        <MusicTable music={music} isLoading={isLoading} onClickDelete={this.deleteMusic} />
      </>
    );
  };
}

const mapDispatchToProps = (dispatch: Function) => ({
  deleteMusic: (musicId: string) => dispatch(deleteAfterEffectsMusic(musicId)),
  uploadAfterEffectsMusic: (body: MusicUploadFormDataProps) => dispatch(uploadAfterEffectsMusicFile(body)),
  closeMusicUploadModal: () => dispatch(createModalCloseAction(SimpleModalId.AddMusicModal)),
  getAfterEffectsMusic: () => dispatch(getAfterEffectsMusicFiles()),
});

const mapStateToProps = (state: ClippingPlatformState) => baseMapStateToProps(state);

export const MusicManagementContainer = connect(mapStateToProps, mapDispatchToProps)(MusicManagement);
